module.exports = __webpack_public_path__ + "img/1.4384613d.png";